import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Header() {
  const location = useLocation();
  const pathname = location.pathname;
  const initialMenu =
    sessionStorage.getItem("myMenu") ||
    "light-style layout-navbar-fixed layout-compact layout-menu-fixed";
  const initialToggle = sessionStorage.getItem("myToggle") === "true";

  const [menu, setMenu] = useState(initialMenu);
  const [toggle, setToggle] = useState(initialToggle);

  useEffect(() => {
    sessionStorage.setItem("myMenu", menu);
    sessionStorage.setItem("myToggle", toggle);

    document.documentElement.className = menu;
  }, [menu, toggle]);

  const changeMenuOnHover = () => {
    if (toggle) {
      setMenu(
        "light-style layout-navbar-fixed layout-compact layout-menu-fixed layout-menu-collapsed layout-menu-hover"
      );
    } else {
      setMenu(
        "light-style layout-navbar-fixed layout-compact layout-menu-fixed"
      );
    }
  };

  const changeMenuOffHover = () => {
    if (toggle) {
      setMenu(
        "light-style layout-navbar-fixed layout-compact layout-menu-fixed layout-menu-collapsed"
      );
    } else {
      setMenu(
        "light-style layout-navbar-fixed layout-compact layout-menu-fixed"
      );
    }
  };

  const changeMenuOnClick = () => {
    setMenu(
      "light-style layout-navbar-fixed layout-compact layout-menu-fixed layout-menu-collapsed"
    );
    setToggle(!toggle);
  };
  const user_permissions = localStorage.getItem("user_permissions");
  const permissions = JSON.parse(user_permissions);
  const [myPermissions, setMyPermissions] = useState([]);

  useEffect(() => {
    console.log("permissions", permissions);
    if (permissions) {
      const urls = permissions.map((permission) => permission?.route?.url);
      setMyPermissions(urls);
    }
  }, []);

  return (
    <>
      <aside
        id="layout-menu"
        className="layout-menu menu-vertical menu bg-menu-theme"
        onMouseOver={changeMenuOnHover}
        onMouseOut={changeMenuOffHover}
      >
        <div className="app-brand demo">
          <Link to={"/"} className="app-brand-link">
            <span className="app-brand-logo demo me-1">
              <img src="/logo3.png" style={{ width: "50px" }} alt="" />
            </span>
            <span className="app-brand-text demo menu-text fw-semibold ms-2">
              Yard
            </span>
          </Link>
          <a
            href="#"
            className="layout-menu-toggle menu-link text-large ms-auto"
          >
            <i
              className="menu-toggle-icon d-xl-block align-middle"
              onClick={changeMenuOnClick}
            />
          </a>
        </div>
        <div className="menu-inner-shadow" />
        <ul className="menu-inner py-1">
          {myPermissions && myPermissions?.includes("/") && (
            <li className={`menu-item ${pathname == "/" ? "active" : ""}`}>
              <Link to={"/"} className="menu-link">
                <i className="menu-icon tf-icons ri-home-smile-line" />
                <div data-i18n="Dashboard">Dashboard</div>
              </Link>
            </li>
          )}

          {myPermissions && myPermissions?.includes("/mapping") && (
            <li
              className={`menu-item ${pathname == "/mapping" ? "active" : ""}`}
            >
              <Link to={"/mapping"} className="menu-link">
                <i className="menu-icon tf-icons ri-road-map-line" />
                <div data-i18n="Yard-Map">Yard-Map</div>
              </Link>
            </li>
          )}

          {myPermissions && myPermissions?.includes("/strategy") && (
            <li
              className={`menu-item ${pathname == "/strategy" ? "active" : ""}`}
            >
              <Link to={"/strategy"} className="menu-link">
                <i className="menu-icon tf-icons ri-lightbulb-flash-line" />
                <div data-i18n="Strategy">Strategy</div>
              </Link>
            </li>
          )}

          {myPermissions && myPermissions?.includes("/containers") && (
            <li
              className={`menu-item ${
                pathname == "/containers" ? "active" : ""
              }`}
            >
              <Link to={"/containers"} className="menu-link">
                <i className="menu-icon tf-icons ri-instance-line" />
                <div data-i18n="KYCL">KYCL</div>
              </Link>
            </li>
          )}
          {myPermissions &&
            myPermissions?.includes("/reports/long-standing-container") && (
              <li
                className={`menu-item ${
                  pathname == "/reports/long-standing-container" ? "active" : ""
                }`}
              >
                <Link
                  to={"/reports/long-standing-container"}
                  className="menu-link"
                >
                  <i className="menu-icon tf-icons ri-file-line" />
                  <div data-i18n="Long Standing">Long Standing</div>
                </Link>
              </li>
            )}

          {myPermissions && myPermissions?.includes("/container-history") && (
            <li
              className={`menu-item ${
                pathname == "/container-history" ? "active" : ""
              }`}
            >
              <Link to={"/container-history"} className="menu-link">
                <i className="menu-icon tf-icons ri-route-line" />
                <div data-i18n="Container History">Container History</div>
              </Link>
            </li>
          )}
          {myPermissions && myPermissions?.includes("/jobs") && (
            <li className={`menu-item ${pathname == "/jobs" ? "active" : ""}`}>
              <Link to={"/jobs"} className="menu-link">
                <i className="menu-icon tf-icons ri-sofa-line" />
                <div data-i18n="Jobs">Jobs</div>
              </Link>
            </li>
          )}
          {myPermissions && myPermissions?.includes("/kycl") && (
            <li className={`menu-item ${pathname == "/kycl" ? "active" : ""}`}>
              <Link to={"/kycl"} className="menu-link">
                <i className="menu-icon tf-icons ri-map-line" />
                <div data-i18n="Yard-Transactions">Yard Transactions</div>
              </Link>
            </li>
          )}
          {myPermissions && myPermissions?.includes("/g_map") && (
            <li className={`menu-item ${pathname == "/g_map" ? "active" : ""}`}>
              <Link to={"/g_map"} className="menu-link">
                <i className="menu-icon tf-icons ri-map-pin-line" />
                <div data-i18n="Live-CHE-Tracking">Live CHE Tracking</div>
              </Link>
            </li>
          )}

          {myPermissions && myPermissions?.includes("/liveItvTracking") && (
            <li
              className={`menu-item ${
                pathname == "/liveItvTracking" ? "active" : ""
              }`}
            >
              <Link to={"/liveItvTracking"} className="menu-link">
                <i className="menu-icon tf-icons ri-map-pin-line" />
                <div data-i18n="Live ITV Tracking">Live ITV Tracking</div>
              </Link>
            </li>
          )}
          {myPermissions && myPermissions?.includes("/stacks") && (
            <li
              className={`menu-item ${pathname == "/stacks" ? "active" : ""}`}
            >
              <Link to={"/stacks"} className="menu-link">
                <i className="menu-icon tf-icons ri-pin-distance-line" />
                <div data-i18n="Stowage-Plan">Stowage Plan</div>
              </Link>
            </li>
          )}
          {myPermissions && myPermissions?.includes("/che-report") && (
            <li
              className={`menu-item ${
                pathname == "/che-report" ? "active" : ""
              }`}
            >
              <Link to={"/che-report"} className="menu-link">
                <i className="menu-icon tf-icons ri-file-settings-line" />
                <div data-i18n="CHE Report">CHE Report</div>
              </Link>
            </li>
          )}
          {myPermissions && myPermissions?.includes("/eir-report") && (
            <li
              className={`menu-item ${
                pathname == "/eir-report" ? "active" : ""
              }`}
            >
              <Link to={"/eir-report"} className="menu-link">
                <i className="menu-icon tf-icons ri-file-line" />
                <div data-i18n="EIR Report">EIR Report</div>
              </Link>
            </li>
          )}
        </ul>
      </aside>
    </>
  );
}
